import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import FormSelect from "core/gd-form/form-element/select-new/select-new";

export default function CustomFieldSymbol(props) {

    const getSymbolOptions = () => {
        const res = [];
        for (let prop in gd.const.currency){
            const { label, value } = gd.const.currency[prop];
            res.push({label: label, value:value});
        }
        return res;
    }

    return (
        <FormRow label="Symbol">
            <FormSelect form={props.form}
                        name="symbol"
                        options={getSymbolOptions()}
                        placeholder="Symbol" />
            <FormError form={props.form} name="symbol" />
        </FormRow>
    );
}

CustomFieldSymbol.propTypes = {
    form: PropTypes.object
}